export enum CustomerTrackingState {
  CREATED,
  IN_TRANSIT,
  NEARBY,
  ARRIVED,
  WAITING,
  DEPARTED,
  COMPLETE
}
